import create from 'zustand';
import { persist } from 'zustand/middleware';

const useUserStore = create(
  persist(
    (set) => ({
      slackCode: '',
      setSlackCode: (value: string) => set(() => ({ slackCode: value })),
      isCreatingFlowForTheFirstTime: false,
      setCreatingFlowForTheFirstTime: (val: boolean) =>
        set(() => ({ isCreatingFlowForTheFirstTime: val })),
    }),
    {
      name: 'user-settings',
    },
  ),
);

export default useUserStore;
